module.exports = __webpack_public_path__ + "img/1.f14cdf42.png";